'use strict';

angular.module('chatEngine.engines.custom', [])

.controller('CustomEngineCtrl', ['$scope', '$window', '$timeout', 'Engine', 'Dialog', 'URL_REGEX',
    function($scope, $window, $timeout, Engine, Dialog, URL_REGEX) {
    $scope.editing = false;
    $scope.newValue = null;
    $scope.oldValue = null;
    $scope.savingEdit = false;
    $scope.hasTyped = false;
    $scope.animateOut = false;

    $scope.canActivate = function() {
        return true;
    };

    $scope.completeURL = function(url) {
        if(!url) {
            return null;
        }
        if(url.indexOf('http://') === -1 &&
            url.indexOf('https://') === -1) {
            url = 'http://' + url;
        }
        return url;
    };

    $scope.isFormValid = function() {
        return !$scope.newValue || URL_REGEX.test($scope.completeURL($scope.newValue || ''));
    };

    $scope.saveEdit = function() {
        if($scope.isFormValid()) {
            $scope.savingEdit = true;
            $scope.engineData.url = $scope.completeURL($scope.newValue);

            Engine.update({
                id: $scope.engineData.id
            }, $scope.engineData, editSaved, editFailed);
        }
    };

    $scope.setEditMode = function(option) {
        if (!option) {
            $scope.hasTyped = false;
            $scope.animateOut = true;
            $timeout(function() {
                $scope.editing = false;
                $scope.animateOut = false;
            }, 500);

            $scope.newValue = $scope.engineData.url;
        } else if ($scope.editing !== true) {
            $scope.editing = true;

            $scope.savingEdit = false;
            $scope.newValue = $scope.engineData.url;
            $scope.oldValue = $scope.engineData.url;
        }
    };

    $scope.shouldShowBreadcrumbs = function() {
        var engineData = Engine.getData();
        for(var id in engineData) {
            // If the bot has a single engine that is not custom, then we should show the breadcrumbs
            if(engineData[id].type !== 'custom') {
                return true;
            }
        }
        return false;
    };

    function editSaved(data) {
        $scope.savingEdit = false;
        $scope.engineData = data;
        $scope.hasTyped = false;

        $scope.setEditMode(false);

        $scope.newValue = $scope.engineData.url;
    }

    function editFailed(response) {
        // Resetting the original value (to avoid confusion)
        $scope.savingEdit = false;
        $scope.engineData.url = $scope.oldValue;

        if (response.status === 400 && response.data.error === 'InvalidParameters') {
            Dialog.alert('Error', 'Looks like you entered an invalid URL. Please update and try again.');
        } else {
            Dialog.alert('Error', 'Something went wrong while updating your engine, please try again later.');
        }
    }

    $scope.init('custom');

    if(!$scope.engineData.url) {
        $scope.setEditMode(true);
    } else {
        $scope.newValue = $scope.engineData.url;
    }
}]);
